  //This clears the hamburger menu if the Back button is clicked in the browser
  (function () {
	window.onpageshow = function(event) {
		if (event.persisted) {
			window.location.reload();
		}
	};
})();

//This makes scroll event listeners passive for performance
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

jQuery(document).ready( function() {
  if(jQuery(window).scrollTop() > 14) {
    jQuery('header').removeClass('pursuit_header_change');
  } else {
    jQuery('header').addClass('pursuit_header_change');
  }
  //Add and remove class on scroll for header transparency
  jQuery(window).on("scroll load", function() {
    if(jQuery(window).scrollTop() > 14) {
      jQuery('header').removeClass('pursuit_header_change');
    } else {
      jQuery('header').addClass('pursuit_header_change');
    }
  });
  //Hamburger menu opener
  jQuery(".hamburger").on("click touch", function() {
    jQuery(".hamburger").toggleClass("is-active");
    jQuery(".hamMenuBlock").removeClass("hamMenuStart");
    jQuery(".hamMenuBlock").toggleClass("hamMenuBlockOpen");
    jQuery(".hamMenuBlock").toggleClass("hamMenuBlockClose");
    //jQuery("body").toggleClass("scrollStopper");
    if (jQuery(".hamMenuBlock").hasClass("hamMenuBlockClose")) {
      jQuery(".hamMenuBlock").delay(700).queue(function(next){
        jQuery(".hamMenuBlock").addClass("hamMenuStart");;
        next();
      });
    }
  });
  //Hamburger menu sub menus
  jQuery('.hamMenuLinkSubArrow').on('click', function(){
    var thisAnswer = jQuery(this).parent().nextAll('.hamMenuLinkMainSubBlock').first();
    var thisQuestion = jQuery(this).parent();
    jQuery('.hamMenuLinkMainSubBlock').not(thisAnswer).slideUp('fast');
    jQuery(thisAnswer).slideToggle('fast');
    jQuery(thisQuestion).toggleClass('hamMenuLinkMainActive');
    jQuery('.hamMenuLinkSubArrow').not(this).removeClass('hamMenuLinkSubArrowUp');
    jQuery(this).toggleClass('hamMenuLinkSubArrowUp');
  });
  //
  jQuery('.dropdown-menu').hover(function(){
    var thisMain = jQuery(this).prev().find('span');
    jQuery(this).prev().find('span').addClass("nav-link__active");
  }, function () {
    jQuery(this).prev().find('span').removeClass("nav-link__active");
  });
  //Accordion module
  jQuery('.pd_accordionItemTitle').click(function(){
    jQuery(this).attr('aria-expanded', function(index, attr){
      return attr == 'false' ? 'true' : 'false';
    });
    var thisContent = jQuery(this).next('.pd_accordionItemContent');
    jQuery('.pd_accordionItemContent').not(thisContent).slideUp('fast').attr('aria-hidden', 'true');
    jQuery(thisContent).slideToggle('fast').attr('aria-hidden', function(index, attr){
      return attr == 'true' ? 'false' : 'true';
    });
    jQuery('.pd_accordionItemTitle').not(this).removeClass('pd_accordionItemTitleOn').attr('aria-expanded', 'false');
    jQuery(this).toggleClass('pd_accordionItemTitleOn');
  });
  //Logo Slider module - uses Slick.js
  jQuery('.pursuit_logo_slider').slick({
    speed: 8600,
    slidesToShow: 9,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    arrows: false,
    dots: false,
    cssEase: 'linear',
    draggable: false,
    touchMove: false,
    pauseOnHover: false,
    responsive: [{
      breakpoint: 1009,
      settings: {
        speed: 6800,
        slidesToShow: 6
      }
    }, {
      breakpoint: 782,
      settings: {
        speed: 5500,
        slidesToShow: 2
      }
    }]
  });
  //Add title attribute to all iframe elements
  if (!jQuery('iframe').attr('title')) {
    jQuery('iframe').attr('title', 'Content from Quantum Speed Works');
  }
});
